import styled from 'styled-components';

import { ReferralSteps } from 'components/modals/referral/form/helpers';
import { ReferralFormMeta, ReferralFormValues } from 'components/modals/referral/SendReferralModal';
import { Form, useForm } from 'context/form';
import LocationEpisode from 'models/LocationEpisode';
import { BodySmall } from 'styles/typography';

import EditDeterminantsStep from './EditDeterminantsStep';
import ReferToStep from './ReferToStep';

type ReferralFormProps = {
  locationEpisode: LocationEpisode;
  initialPhoneNumber: string;
};

export default function ReferralForm(props: ReferralFormProps) {
  const { locationEpisode, initialPhoneNumber } = props;

  const { meta } = useForm<ReferralFormValues, ReferralFormMeta>();

  // NOTE: do not add a `values.note` writer at this level. ReferToStep owns
  // the note (its own useActivityInput) and syncs it into form values. A
  // duplicate writer here held an empty mount-time snapshot of the note and
  // re-wrote it whenever `setValue` identity changed — silently wiping the
  // note's attachments and text from the submitted referral (OLIO-2638).

  return (
    <>
      {meta.currentStep === ReferralSteps.ReferTo && (
        <BodySmall>
          Select a provider to send a referral in Olio. The provider can then coordinate the approval or denial of the
          referral in Olio.
        </BodySmall>
      )}
      <Form>
        <FormContainer>
          {meta.currentStep === ReferralSteps.ReferTo && <ReferToStep locationEpisode={locationEpisode} />}

          {meta.currentStep === ReferralSteps.Determinants && (
            <EditDeterminantsStep initialPhoneNumber={initialPhoneNumber} />
          )}
        </FormContainer>
      </Form>
    </>
  );
}

const FormContainer = styled.div`
  margin-top: 20px;
`;
